module.exports = __webpack_public_path__ + "img/user-vip-yq.16f5803e.png";